import { render, staticRenderFns } from "./TwodThreed.vue?vue&type=template&id=480f2f70&scoped=true"
import script from "./TwodThreed.vue?vue&type=script&lang=js"
export * from "./TwodThreed.vue?vue&type=script&lang=js"
import style0 from "./TwodThreed.vue?vue&type=style&index=0&id=480f2f70&prod&scoped=true&lang=css"
import style1 from "./TwodThreed.vue?vue&type=style&index=1&id=480f2f70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480f2f70",
  null
  
)

export default component.exports